import { createFileRoute } from '@tanstack/react-router';
import ComingSoonCover from '@/components/ComingSoonCover';
function RuleAndPolicyRoute() {
  return <ComingSoonCover />;
}
export const Route = createFileRoute('/_staff/attendances/_layout/rule-and-policy/')({
  component: RuleAndPolicyRoute
});